<template>
    <div>
        <b-row class="mt-4 mb-5" align-h="center">
            <b-col cols="3">
                <b-card
                        :style="info.type==1 || info.type==3 ?'background:rgba(15, 55, 110, 0.3)':''"
                        :header="info.tipo"
                        header-class="header-info"
                        class="mx-auto card-info text-center"
                >
                    <b-card-text>
                        <p v-if="info.tipo=='Instrucciónes'" class="info-text">Generales</p>
                        <p v-else class="info-text">Simulacro</p>

                        <br/>
                        <b-row align-h="around">
                            <p>
                                <img
                                        style="cursor:pointer"
                                        @click="editar()"
                                        class=""
                                        src="@/assets/images/editinfo.png"
                                        alt
                                />

                            </p>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col cols="3">
                <b-card
                        :style="info.type==2 || info.type==4 ?'background:rgba(15, 55, 110, 0.3)':''"
                        :header="info.tipo"
                        header-class="header-info"
                        class="card-info text-center"
                >
                    <b-card-text>
                        <p v-if="info.tipo=='Instrucciónes'" class="info-text">Por Módulo</p>
                        <p v-else class="info-text">Resultados</p>
                        <br/>
                        <b-row align-h="around">
                            <p>
                                <img
                                        style="cursor:pointer"
                                        @click="editar()"
                                        class=""
                                        src="@/assets/images/editinfo.png"
                                        alt
                                />

                            </p>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="mt-4 m-4" align-h="start">
            <b-col cols="3">
                <p v-if="info.type !== 2"  @click="agregar()" class="plus-simulacro">
                    <img src="@/assets/images/plus.png" alt/>
                    Agregar nuevo
                </p>
            </b-col>
        </b-row>
        <b-row v-for="(items, key) in contenido" :key="key" align-h="center" align-v="center">
            <b-col cols="10" style="border-color:#0F376E" class="filaCarrera">
                <b-row>
                    <b-col align-self="center" cols="9">
                        <p v-if="info.type === 2" class="titulo-simulacro-admin" style>{{items.nombreModulo}}</p>
                        <p v-else class="titulo-simulacro-admin" style>{{items.nombre}}</p>
                    </b-col>
                    <b-col cols="1" class>
                        <p style="cursor:pointer" @click="modificar(items)" class="modificar-carrera">Modificar</p>
                    </b-col>
                    <b-col cols="2">
                        <button v-if="info.type === 1" class="button-modificar-carrera" @click="eliminar(items)">Eliminar</button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal
                no-enforce-focus
                content-class="modal-info"
                hide-footer
                ref="modal-info"
                centered
                size="lg"
        >
            <b-row class="mt-4" align-h="center">
                <b-col lg="9">
                    <p class="title-edit">Nombre de la instruccion</p>
                    <b-input
                            required
                            placeholder="Nombre"
                            class="simulacro-register"
                            type="text"
                            v-model="nombre"
                    />
                </b-col>
            </b-row>
            <b-row class="mt-4" align-h="center">
                <b-col lg="9">
                    <editor
                            initial-value
                            api-key="gesewuu9jwv1p9la48mwzsnrniuxuei3vugq45y6ygffctjq"
                            v-model="informacion"
                            :init="{
          images_upload_url: this.http + '//' + this.api + '/api/imageUpload',
         height: 500,
         menubar: true,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         toolbar:
             'bold italic  | \
           alignleft aligncenter alignright alignjustify | \
           bullist'
       }"
                    />
                </b-col>
            </b-row>
            <b-row align-h="center" class="mb-4 mt-5">
                <button
                        @click="agregarInfo()"
                        style="background:#0F376E!important"
                        class="password-aceptar"
                >AGREGAR
                </button>
            </b-row>
        </b-modal>
        <b-modal content-class="modal-delete-instruccion" hide-footer ref="modal-delete-instruccion" centered size="lg">
            <b-row align-h="center" class="mt-5 examen-finish">
                <p class="fondo-carrera" style="color:#0F376E">Eliminar instruccion</p>
            </b-row>
            <b-row align-h="center" class="mt-n4">
                <b-col lg="8">
                    <b-input
                            disabled
                            placeholder="Nombre"
                            class="simulacro-register"
                            type="text"
                            v-model="nombreInstruccion"
                    />
                </b-col>
            </b-row>
            <b-row align-h="center" class="mb-1 mt-3 ml-1">
                <b-col lg="4">
                    <button
                            @click="cancel2()"
                            style="color:#0F376E!important"
                            class="modal-button-cancel"
                    >CANCELAR</button>
                </b-col>
                <b-col lg="4">
                    <button
                            @click="deleteInstruccion()"
                            style="background-color:#0F376E!important"
                            class="modal-button-accept"
                    >ACEPTAR</button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>
<script>
    import Editor from "@tinymce/tinymce-vue";
    import configs from "../../local_config";

    export default {
        name: "Editar",
        components: {editor: Editor},

        data: () => ({
            api: configs.API,
            http: configs.HTTP_API,
            simulacros: "",
            informacion: "",
            nombre: "",
            contenido: [],
            info: "",
            nombreInstruccion: '',
            iditemdelete: ''
        }),
        created() {
            this.info = localStorage.getItem("info");
            this.info = JSON.parse(this.info);
            console.log('this.info.tipo', this.info);
            this.$store.dispatch("setModulo", 'Modificar '+this.info.tipo);//'Modificar '+this.info.tipo
            this.$store.dispatch("setNav", "active");
            this.$store.dispatch("setNavRoute", "admin/Information");
            this.getContenido();
        },
        methods: {
            getContenido() {
                this.info = localStorage.getItem("info");
                this.info = JSON.parse(this.info);
                switch (this.info.type) {
                    case 1:
                        this.$store
                            .dispatch(
                                "getInstruccionesGenereales",
                                localStorage.getItem("id_simulacro")
                            )
                            .then(response => {
                                this.contenido = response.data.instruccion;
                            })
                            .catch(error => {
                                console.log(error.message);
                            });
                        break;
                    case 2:
                        this.$store
                            .dispatch(
                                "getInstruccionesModulos",
                                localStorage.getItem("id_simulacro")
                            )
                            .then(response => {
                                console.log(response.data.instruccion, 'response.data.instruccion');
                                this.contenido = response.data.instruccion;
                            })
                            .catch(error => {
                                console.log(error.message);
                            });
                        break;
                    case 3:
                        this.$store
                            .dispatch(
                                "getAnimacionesSimulacros",
                                localStorage.getItem("id_simulacro")
                            )
                            .then(response => {
                                this.contenido = response.data.animacion;
                            })
                            .catch(error => {
                                console.log(error.message);
                            });
                        break;
                    case 4:
                        this.$store
                            .dispatch(
                                "getAnimacionesResultados",
                                localStorage.getItem("id_simulacro")
                            )
                            .then(response => {
                                this.contenido = response.data.animacion;
                            })
                            .catch(error => {
                                console.log(error.message);
                            });
                        break;
                    default:
                        break;
                }
            },
            agregarInfo() {
                let data = {
                    tipo: this.info.type,
                    id_simulacro: localStorage.getItem("id_simulacro"),
                    nombre: this.nombre,
                    informacion: this.informacion
                };
                this.$store
                    .dispatch("postInfo", data)
                    .then(response => {
                        this.contenido = response.data.animacion;
                        this.getContenido();
                        this.$refs["modal-info"].hide();
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
                this.nombre = "";
                this.informacion = "";
            },
            agregar() {
                this.$refs["modal-info"].show();
            },
            editar() {
                var info;
                switch (this.info.type) {
                    case 1:
                        info = {
                            tipo: this.info.tipo,
                            nombre: "por Módulo",
                            type: 2
                        };
                        break;
                    case 2:
                        info = {
                            tipo: this.info.tipo,
                            nombre: "Generales",
                            type: 1
                        };
                        break;
                    case 3:
                        info = {
                            tipo: this.info.tipo,
                            nombre: "Resultados",
                            type: 4
                        };
                        break;
                    case 4:
                        info = {
                            tipo: this.info.tipo,
                            nombre: "Simulacros",
                            type: 3
                        };
                        break;
                }

                localStorage.setItem("info", JSON.stringify(info));
                this.getContenido();
            },
            modificar(item) {
                console.log('item************>',item)
                localStorage.setItem("item", JSON.stringify(item));
                this.$router.push('/admin/Information/interna');
            },
            eliminar(item) {
                if(this.info.type === 1) {
                    this.nombreInstruccion = item.nombre
                    switch (this.info.type) {
                        case 1:
                            this.iditemdelete = item.id_instruccion
                            break;
                        case 2:
                            break;
                        case 3:
                            this.iditemdelete = item.id_animacion
                            break;
                        case 4:
                            break;
                    }
                    this.$refs["modal-delete-instruccion"].show();
                } else {
                    this.$alert("No se puede eliminar este modulo", 'Opción', 'warning');
                }
            },
            cancel2(){
                this.$refs["modal-delete-instruccion"].hide();
            },
            deleteInstruccion() {
                console.log('eliminar deleteInstruccion', this.iditemdelete)
                switch (this.info.type) {
                    case 1:
                        this.$store
                            .dispatch("deleteInstruccion", this.iditemdelete)
                            .then((response) => {
                                console.log('deleteInstruccion', response.data.status);
                                this.$refs["modal-delete-instruccion"].hide();
                                this.getContenido();
                            })
                            .catch(error => {
                                console.log(error.message);
                            });
                        break;
                    case 2:
                        break;
                    case 3:
                        this.$store
                            .dispatch("deleteAnimacion", this.iditemdelete)
                            .then((response) => {
                                console.log('deleteAnimacion', response.data.status);
                                this.$refs["modal-delete-instruccion"].hide();
                                this.getContenido();
                            })
                            .catch(error => {
                                console.log(error.message);
                            });
                        break;
                    case 4:
                        break;
                }

            },
        },
        computed: {
            isAdmin() {
                return this.$store.getters["isAdmin"];
            }
        }
    };
</script>
<style scoped>
</style>